import React, { useState, useEffect , useRef} from 'react'
import Header from "../Component/Header";
import { Link } from 'react-router-dom' 
import HomeSlider from '../Component/HomeSlider'
import News from '../Component/News'
import HomeEvent from '../Component/Events'
import Gallery from '../Component/Gallery'
import TopperXII from '../Component/TopperXII' 
import TopperX from '../Component/TopperX' 
import Popup from'../Component/Popup'
import OnlineRegistration from'../Component/OnlineRegistration'
const Home = () => {
   useEffect(() => {
      document.title = ' The Air Force School Subroto Park';  
  }, []);  
   const [isVisible, setIsVisible] = useState(false);
   const sectionRef = useRef(null); // Ref for the target section
 
   // Callback function to be called when the section comes into view
   const handleIntersection = (entries) => {
     const [entry] = entries;
     // If the section is in view, trigger the animation
     setIsVisible(entry.isIntersecting);
   };
 
   useEffect(() => {
     // Set up the IntersectionObserver to monitor the section
     const observer = new IntersectionObserver(handleIntersection, {
       root: null, // Observe the viewport
       threshold: 0.3, // Trigger when 50% of the section is in view
     });
 
     if (sectionRef.current) {
       observer.observe(sectionRef.current); // Start observing the section
     }
 
     // Clean up the observer when the component unmounts
     return () => {
       if (sectionRef.current) {
         observer.unobserve(sectionRef.current);
       }
     };
   }, []);
   // const [isHovered, setIsHovered] =  useState(false);
   // const handleMouseEnter = () => setIsHovered(true);
   // const handleMouseLeave = () => setIsHovered(true);
  return (
     <>
   
     <Header/>
       <OnlineRegistration/>
          <Popup/>
           <HomeSlider/> 
           <div ref={sectionRef} className="aboutdiv">
                    <div className="container">
                           <div className="aboutsec">
                              <div className="row">
                                    <div className="col-lg-4"> 
                                       <div className="aboutsecimg">
                                           <div className="circle">
                                              <img src="https://webapi.entab.info/api/image/TAFS/public/Images/dimg.png" className="img-fluid circlemb"/>
                                              <div className="circleborder">
                                                <img src="https://webapi.entab.info/api/image/TAFS/public/Images/aboutimg.png" className="img-fluid circledsk"/>
                                           </div>
                                           </div>
                                       </div>
                                    </div>
                                    <div className="col-lg-8">  
                                          
                                     { /*  <div className={`flagdiv ${isHovered ? 'hovered' : ''}`} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                           <div className="flagfst"></div>
                                           <div className="flagimg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/flag.jpg" className="img-fluid"/></div>
                                           <div className="flagscd"></div>
                                       </div>  */ 
  }
  
 
  {isVisible && (
   <div className={`flagdiv ${isVisible ? 'visible' : ''}`}>
     <div className="flagfst"></div>
     <div className="flagimg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/flag.jpg" className="img-fluid"/></div>
     <div className="flagscd"></div>
   </div>
 )}                       
                                          <div className="title">
                                                <p>Welcome to</p>
                                                <h2>The Air force School</h2>
                                          </div>
                                          <p>The Air Force School (TAFS) was established in temporary wartime hutments at Wellingdon Camp, Club Road, New Delhi on 18 July 1955 with the aim of providing comprehensive modern education to children of personnel of the Indian Air Force. In May 1967, the school shifted to its present Aravali Campus at Subroto Park, Delhi Cantt. The school celebrated its Silver Jubilee in 1980.</p>
                                        <Link to="/History" className="readmore">Read More</Link>
                                          </div>
                                    </div>
                           </div>
                          <div className="aboutnews">
                              <div className="title">
                                   
                                    <h2>    EVENTS /  CIRCULARS</h2>
                              </div>
                              <div className="row">
                                    <div className="col-lg-6">
                                    <HomeEvent/>
                                    </div>
                                    <div className="col-lg-6">
                                    <News/>
                                    </div>
                              </div>
                          </div>
                    </div>
           </div>
           <div className="gallerysec fwidth">
                <Gallery/>
           </div>
           <div className="usefulsec fwidth">
            <div className="title">  
                  <img src="https://webapi.entab.info/api/image/TAFS/public/Images/useful.gif" className="img-fluid"/>
                     <h2>useful<span> links</span> </h2>
               </div>
                  <div className="container"> 
                  <ul className="usefullinks"> 
                  <li><Link to="/ClassesUKGtoV">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink1.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Classes</span> UKG - V</p></div> 
               </Link></li>
               <li><Link to="/ClassesVItovIII">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink2.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Classes</span>  VI - VIII</p></div> 
               </Link></li>
               <li><Link to="/ClassesIXtoX">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink3.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Classes</span>  IX - X</p></div> 
               </Link></li>
               <li><Link to="/ClassesXItoXII">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink4.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Classes</span>  XI - XII</p></div> 
               </Link></li>
               <li><Link to="/SchoolCalendar">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink5.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>School</span>  Calendar</p></div> 
               </Link></li>
               <li><Link to="/FeeStructure">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink6.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Fee</span>   Structure</p></div> 
               </Link></li>
               <li><Link to="/Achievements">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink7.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Achievements</span>  </p></div> 
               </Link></li>
                { /*  <li><Link to="/PreventiveMeasures">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink8.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Preventive</span>  Measures</p></div> 
               </Link></li>
               <li><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Measure.pdf" target="_blank">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink9.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Measure</span>  to reduce weight of school bag</p></div> 
               </Link></li> */}
               <li><Link to="/Magazine">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink10.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Online</span>  Magazine /  Newsletter</p></div> 
               </Link></li>
               <li><Link to="/TransportRules">
                  <div className="usefullinksimg"> <img src="https://webapi.entab.info/api/image/TAFS/public/Images/usefullink11.gif" className="img-fluid"/></div>
                  <div className="usefullinksdesc"><p><span>Transport</span>  Rules</p></div> 
               </Link></li>
                  </ul>
              
                  </div>
                  <div className="talentsec">
                        <div className="talentsecrow">
                            <div className="talentseccol1">
                                <div className="talentsecimg">
                                    <img src="https://webapi.entab.info/api/image/TAFS/public/Images/talent.png" className="img-fluid"/>
                                    <div className="talentmobile">
                                    <div className="talentsecimgdesc">
                                    <p>Consistently Ranked</p>
                                   <h4>#1</h4>
                                   <p>School in South West Delhi</p>
                                   </div>
                                   <div className="talentseccol2">
                               <div className="talentsecright"><h5><span>T</span>ALENT <span>A</span>SPIRATION <span>F</span>OCUS <span>S</span>OLIDARITY</h5></div>
                           </div>
                                    </div>
                                </div> 
                                
                            </div>
                           
                        </div>
                  </div>
           </div>
           <div className="achievement fwidth">
               <div className="container-fluid fulwidth">
                        <div className="row achievementleft">
                              <div className="col-lg-6 col-md-6 topper12bx">
                                    <img src="https://webapi.entab.info/api/image/TAFS/public/Images/classicn.png" className="img-fluid topperrib"/>
                              <TopperXII/>
                              <Link className="gallery_button" to="/TopperXII"> View All</Link>
                              </div>
                              <div className="col-lg-6 col-md-6 topper10bx">
                                             <img src="https://webapi.entab.info/api/image/TAFS/public/Images/classicn10.png" className="img-fluid topperrib"/>
                              <TopperX/>
                              <Link className="gallery_button" to="/TopperX"> View All</Link> 
                              </div>
                        </div>
                     </div>
               

                  { /*   <div className="achievementleft">
                <h6>Achievements <div className='gif'><img src="https://webapi.entab.info/api/image/TAFS/public/Images/Achievements.gif"/></div></h6> 
                     <div className="achievementslider"> 
                         <Achievement/>
                        
                     </div>
                     <Link to="/Achievements" className="gallery_button"> Read More</Link>
                </div>
                <div className="achievementright">
                       <h6>Legacy leaders</h6>
                       <p>A celebration of Tafsian Spirit</p>
                       <Link to="/" className="gallery_button">GET INSPIRED</Link>
                </div> */}
           </div>
           
         </>  
     
  )
}

export default Home
